// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedModalAdd_modal_container__JUto- .ant-modal-content {
    width: 100%;
    height: 820px;
    border-radius: 20px;
}

.ComponentListedModalAdd_modal_container__JUto- .ant-modal-body {
    width: 100%;
    height: 95%;
}

.ComponentListedModalAdd_modal_container__JUto- .ComponentListedModalAdd_footer__pc8HI .ant-form-item {
    margin-bottom: 0;
}

.ComponentListedModalAdd_left_content__f0jpE .ant-form-item {
    margin-bottom: 10px;
}

.ComponentListedModalAdd_main__sSdo8 {
    display: flex;
    width: 100%;
    height: calc(100% - 40px);
}

.ComponentListedModalAdd_main_left__U-7Bj,
.ComponentListedModalAdd_main_right__jtGVv {
    width: 50%;
    height: 100%;
    padding: 0 20px;
    border: 1px solid #ccc;
}

.ComponentListedModalAdd_left_header__zD9wA,
.ComponentListedModalAdd_right_header__-vnnG {
    width: 100%;
    height: 30px;
    margin-bottom: 10px;
    font-size: 20px;
    text-align: center;
}

.ComponentListedModalAdd_footer__pc8HI {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    width: 100%;
    height: 40px;
}

.ComponentListedModalAdd_left_header__zD9wA {

}

.ComponentListedModalAdd_right_header__-vnnG {

}

/* 前台信息 */
.ComponentListedModalAdd_right_header_img_box__USG2J {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.ComponentListedModalAdd_right_header_img__DQQTZ {
    width: 55px;
    height: 55px;
    border: 1px solid #ccc;
    border-radius: 6px;
}

.ComponentListedModalAdd_right_header_butn__uMmh3 {
    margin-right: 10px;
}

.ComponentListedModalAdd_right_header_text_box__krw19 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 5px 0;
    width: 60%;
}

.ComponentListedModalAdd_name_input__eo1kh {
    width: 60%;
}

.ComponentListedModalAdd_right_header_text__DMpl9 {
    margin-bottom: 10px;
}

.ComponentListedModalAdd_introduce_box__tcYfW,
.ComponentListedModalAdd_example_box__dYhlM {
    width: 100%;
    height: 150px;
    padding: 10px 0;
}

.ComponentListedModalAdd_introduce_title__3f\\+iz,
.ComponentListedModalAdd_example_title__mAk4U {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
    text-align: left;
}

.ComponentListedModalAdd_introduce_text__fIGOl,
.ComponentListedModalAdd_example_text__2eRL6 {
    width: 100%;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    color: #414648;
}

.ComponentListedModalAdd_change_avatar__Ntnm\\+ {
    position: absolute;
    top: -16px;
    right: -16px;
    cursor: pointer;
}

.ComponentListedModalAdd_custom_textarea__vdnTI {
    background-color: #f9f9f9;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedModalAdd/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,UAAU;IACV,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".modal_container :global(.ant-modal-content) {\n    width: 100%;\n    height: 820px;\n    border-radius: 20px;\n}\n\n.modal_container :global(.ant-modal-body) {\n    width: 100%;\n    height: 95%;\n}\n\n.modal_container .footer :global(.ant-form-item) {\n    margin-bottom: 0;\n}\n\n.left_content :global(.ant-form-item) {\n    margin-bottom: 10px;\n}\n\n.main {\n    display: flex;\n    width: 100%;\n    height: calc(100% - 40px);\n}\n\n.main_left,\n.main_right {\n    width: 50%;\n    height: 100%;\n    padding: 0 20px;\n    border: 1px solid #ccc;\n}\n\n.left_header,\n.right_header {\n    width: 100%;\n    height: 30px;\n    margin-bottom: 10px;\n    font-size: 20px;\n    text-align: center;\n}\n\n.footer {\n    display: flex;\n    justify-content: center;\n    align-items: flex-end;\n    width: 100%;\n    height: 40px;\n}\n\n.left_header {\n\n}\n\n.right_header {\n\n}\n\n/* 前台信息 */\n.right_header_img_box {\n    position: relative;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.right_header_img {\n    width: 55px;\n    height: 55px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n}\n\n.right_header_butn {\n    margin-right: 10px;\n}\n\n.right_header_text_box {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 5px 0;\n    width: 60%;\n}\n\n.name_input {\n    width: 60%;\n}\n\n.right_header_text {\n    margin-bottom: 10px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    height: 150px;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n    text-align: left;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    color: #414648;\n}\n\n.change_avatar {\n    position: absolute;\n    top: -16px;\n    right: -16px;\n    cursor: pointer;\n}\n\n.custom_textarea {\n    background-color: #f9f9f9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ComponentListedModalAdd_modal_container__JUto-`,
	"footer": `ComponentListedModalAdd_footer__pc8HI`,
	"left_content": `ComponentListedModalAdd_left_content__f0jpE`,
	"main": `ComponentListedModalAdd_main__sSdo8`,
	"main_left": `ComponentListedModalAdd_main_left__U-7Bj`,
	"main_right": `ComponentListedModalAdd_main_right__jtGVv`,
	"left_header": `ComponentListedModalAdd_left_header__zD9wA`,
	"right_header": `ComponentListedModalAdd_right_header__-vnnG`,
	"right_header_img_box": `ComponentListedModalAdd_right_header_img_box__USG2J`,
	"right_header_img": `ComponentListedModalAdd_right_header_img__DQQTZ`,
	"right_header_butn": `ComponentListedModalAdd_right_header_butn__uMmh3`,
	"right_header_text_box": `ComponentListedModalAdd_right_header_text_box__krw19`,
	"name_input": `ComponentListedModalAdd_name_input__eo1kh`,
	"right_header_text": `ComponentListedModalAdd_right_header_text__DMpl9`,
	"introduce_box": `ComponentListedModalAdd_introduce_box__tcYfW`,
	"example_box": `ComponentListedModalAdd_example_box__dYhlM`,
	"introduce_title": `ComponentListedModalAdd_introduce_title__3f+iz`,
	"example_title": `ComponentListedModalAdd_example_title__mAk4U`,
	"introduce_text": `ComponentListedModalAdd_introduce_text__fIGOl`,
	"example_text": `ComponentListedModalAdd_example_text__2eRL6`,
	"change_avatar": `ComponentListedModalAdd_change_avatar__Ntnm+`,
	"custom_textarea": `ComponentListedModalAdd_custom_textarea__vdnTI`
};
export default ___CSS_LOADER_EXPORT___;
